import { Box, useTheme } from "@mui/material";

const CheckBox = (props: any) => {
  const theme = useTheme();
  const { isSelected, handleSelect, sx, ...rest } = props;
  return (
    <Box
      sx={{
        minWidth: "22px",
        minHeight: "22px",
        borderRadius: "8px",
        border: isSelected
          ? `2px solid ${theme.palette.border.dark}`
          : `2px solid ${theme.palette.surface.silver}`,
        backgroundColor: isSelected ? theme.palette.brand.primary : "transparent",
        boxSizing: "border-box",
        cursor: "pointer",
        ...sx,
      }}
      onClick={handleSelect}
      {...rest}
    />
  );
};

export default CheckBox;
